// Marketplace — the promoted badge (practitioner cards + profile promotions sorting
// first within a specialty) and the featured strip (courses/products, C3.02/C3.04).
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "promoted.badge": "Mis en avant",
    "featured.title": "En vedette",
  },
  en: {
    "promoted.badge": "Promoted",
    "featured.title": "Featured",
  },
  es: {
    "promoted.badge": "Promocionado",
    "featured.title": "Destacado",
  },
};
